// type of session-live-stream re-new

export enum MethodLiveType {
  FAVORITE_CATEGORY = 'favoriteCategory',
  RECOMMENDED = 'recommended',
  ATTENTION = 'attention',
  REVENTLY = 'recentlyViewing',
  ROOKIES = 'rookies',
  VOICE = 'voice',
  CLOVER = 'clover',
  FOLLOW = 'follow',
  FIRST_TIME_RECOMMENDED = 'firstTimeRecommended',
  CATEGORY = 'category',
  EVENT = 'event',
}
export enum LeagueLiveType {
  ONE = 'one',
  CLOVER = 'clover',
  ANY = 'any',
}

export enum VoiceLiveType {
  YES = 'yes',
  NO = 'no',
  ANY = 'any',
}

export const LiveMaxDisplay = 12;
export const LiveAllDisplay = 1000;

export enum PathParams {
  HOT = 'hot',
  CLOVER = 'clover',
  ROOKIES = 'rookies',
  FAVORITE_CATEGORY = 'favorite-category',
  RECOMMENDED = 'recommended',
  VOICE = 'voice',
  GACHIIBE = 'ガチイベ',
  WOMEN = '女性',
  MEN = '男性',
  CHATTING = '雑談',
  MUSIC = '音楽',
  MOM = 'ママ',
  COSPLAY = 'コスプレ',
  IDOL = 'アイドル',
  COMEDY = 'お笑い',
  GAME = 'ゲーム',
  STUDENT = '学生',
  VLIVER = 'Vライバー',
}
export interface ILiveRenderListTitle {
  id?: string;
  name: string;
  link?: string;
  type?: string;
}
export const liveTitleHomePage: Array<ILiveRenderListTitle> = [
  {
    name: '注目',
    link: `list/${PathParams.HOT}`,
    type: MethodLiveType.ATTENTION,
  },
  {
    name: '新人',
    link: `list/${PathParams.ROOKIES}`,
    type: MethodLiveType.ROOKIES,
  },
  {
    name: '一般',
    link: `list/${PathParams.CLOVER}`,
    type: MethodLiveType.CLOVER,
  },
];

export interface OptionGlobal {
  numOfPage: number;
  numInPage: number;
}
export const optionGlobal: OptionGlobal = {
  numOfPage: 0,
  numInPage: 1000,
};

export interface ErrorDataResponse {
  errorCode?: number;
  errorMessage?: string;
  message: string;
  statusCode: number;
  timestamp: string;
}
export interface ErrorResponse {
  data: ErrorDataResponse;
  status: number;
}

export const formatDateGlobal = {
  dateFormat: 'MM/DD',
};

export const EXPIRED_TOKEN_TIME = 86399; // 1 day
